export const ROLES = {
  OWNER: 'owner',
  EDITOR: 'editor',
  VIEWER: 'viewer',
};

export const roleOptions = [
  { label: 'Owner', value: ROLES.OWNER },
  { label: 'Editor', value: ROLES.EDITOR },
  { label: 'Viewer', value: ROLES.VIEWER },
];
